import React, { useState } from "react";
import cn from "classnames";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Button from "@mui/material/Button";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { useTranslate } from "../../../../../hooks/useTranslate";
import IconDownload from "../../../../../assets/images/icons/download.svg?react";
import { formatCurrency } from "../../../../../utils/formatCurrency";
import { formatTo } from "../../../../../utils/dateTimeHelper";
import "./BillingTable.css";
import { Link } from "react-router-dom";

const BillingTableRow = (props) => {
    const {
        row, showPay, isHistory, activeStudentId,
    } = props;
    const [open, setOpen] = useState(false);

    const { t } = useTranslate();

    return (
        <>
            <TableRow className={cn("billing-table__row", { "billing-table__row-open": open })}>
                <TableCell>{formatCurrency(row.currency).format(row.amount)}</TableCell>
                <TableCell>
                    <span className={cn("billing-table__status", { "billing-table__status-paid": row.status === "Paid" })}>
                        {row.status}
                    </span>
                </TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.dueDate ? formatTo(row.dueDate, "dd/MM/yyyy") : "-"}</TableCell>
                {isHistory && (
                    <TableCell>{row.paidAt ? formatTo(row.paidAt, "dd/MM/yyyy") : "-"}</TableCell>
                )}
                <TableCell>
                    <div className="flex align-center gap-4">
                        {row.url && (
                            <IconButton
                                size="small"
                                className="billing-table__action-btn"
                                href={row.url}
                                target="_blank"
                            >
                                <RemoveRedEyeOutlinedIcon />
                            </IconButton>
                        )}
                        {row.pdf && (
                            <IconButton
                                size="small"
                                className="billing-table__action-btn"
                                href={row.pdf}
                                target="_blank"
                            >
                                <IconDownload />
                            </IconButton>
                        )}
                        {showPay && (
                            <Link
                                className="billing-table__pay-btn"
                                to={`/finance/pay/${row.invoiceId}/${activeStudentId}`}
                            >
                                {t("payments.payNow")}
                            </Link>
                        )}
                    </div>
                </TableCell>
                <TableCell align="right">
                    {row.lineItems?.length > 0 && (
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            className="billing-table__expand-btn"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    )}
                </TableCell>
            </TableRow>
            {row.lineItems?.length > 0 && (
                <TableRow>
                    <TableCell style={{ padding: 0 }} colSpan={isHistory ? 7 : 6}>
                        <Collapse in={open} timeout="auto" unmountOnExit className="billing-table__details-collapse">
                            <Table size="small" className="billing-table__details-table mt-4 mb-8">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>{t("payments.descriptionOfCharge")}</TableCell>
                                        <TableCell>{t("payments.amountTable")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(row.lineItems || []).map((detail) => (
                                        <TableRow key={detail.id}>
                                            <TableCell>{detail.id}</TableCell>
                                            <TableCell>{detail.description}</TableCell>
                                            <TableCell>{formatCurrency(row.currency).format(detail.amount)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
};

const BillingTable = (props) => {
    const {
        data, showPay, isHistory, activeStudentId, className,
    } = props;
    const { t } = useTranslate();

    return (
        <TableContainer className="billing-table__container">
            <Table className={cn("billing-table", className)} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell width="120">{t("payments.amountTable")}</TableCell>
                        <TableCell width="160">{t("payments.statusTable")}</TableCell>
                        <TableCell>{t("payments.titleTable")}</TableCell>
                        <TableCell>{t("payments.duaDateTable")}</TableCell>
                        {isHistory && (
                            <TableCell width="160">{t("payments.paymentDateTable")}</TableCell>
                        )}
                        <TableCell width="200">{t("payments.actionTable")}</TableCell>
                        <TableCell width="40" align="right" />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(data || []).map((row) => (
                        <BillingTableRow
                            key={row.invoiceId}
                            row={row}
                            showPay={showPay}
                            activeStudentId={activeStudentId}
                            isHistory={isHistory}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BillingTable;
